import { raise } from '@sparkdotfi/common-universal'
import { arbitrum, avalanche, base, gnosis, optimism, unichain } from 'viem/chains'

import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'

export type SavingsDepositActionPath =
  // v2
  | 'usdc-to-spusdc'
  | 'usdt-to-spusdt'
  | 'weth-to-speth'
  | 'eth-to-speth'
  | 'pyusd-to-sppyusd'
  // sky
  | 'usds-to-susds'
  | 'dai-to-susds'
  | 'usdc-to-susds'
  // legacy
  | 'dai-to-sdai'
  | 'usdc-to-susdc'
  // gnosis
  | 'sexy-dai-to-sdai'
  // base
  | 'base-usds-to-susds'
  | 'base-usdc-to-susds'
  | 'base-usdc-to-susdc'
  // arbitrum
  | 'arbitrum-usds-to-susds'
  | 'arbitrum-usdc-to-susds'
  | 'arbitrum-usdc-to-susdc'
  // optimism
  | 'optimism-usds-to-susds'
  | 'optimism-usdc-to-susds'
  | 'optimism-usdc-to-susdc'
  // unichain
  | 'unichain-usds-to-susds'
  | 'unichain-usdc-to-susds'
  | 'unichain-usdc-to-susdc'
  // avalanche
  | 'avalanche-usdc-to-spusdc'
  // opportunities
  | 'usds-to-stusds'

export interface GetSavingsActionPathParams {
  token: Token
  savingsToken: Token
  chainId: number
}

export function getSavingsDepositActionPath({
  token,
  savingsToken,
  chainId,
}: GetSavingsActionPathParams): SavingsDepositActionPath {
  const usds = TokenSymbol('USDS')
  const usdc = TokenSymbol('USDC')
  const dai = TokenSymbol('DAI')
  const sdai = TokenSymbol('sDAI')
  const susds = TokenSymbol('sUSDS')
  const xdai = TokenSymbol('XDAI')
  const susdc = TokenSymbol('sUSDC')
  const usdt = TokenSymbol('USDT')
  const stusds = TokenSymbol('stUSDS')
  const weth = TokenSymbol('WETH')
  const eth = TokenSymbol('ETH')
  const speth = TokenSymbol('spETH')
  const spusdc = TokenSymbol('spUSDC')
  const spusdt = TokenSymbol('spUSDT')
  const pyusd = TokenSymbol('PYUSD')
  const sppyusd = TokenSymbol('spPYUSD')

  if (token.symbol === xdai && savingsToken.symbol === sdai && chainId === gnosis.id) {
    return 'sexy-dai-to-sdai'
  }

  if (chainId === base.id) {
    if (token.symbol === usds && savingsToken.symbol === susds) {
      return 'base-usds-to-susds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susds) {
      return 'base-usdc-to-susds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susdc) {
      return 'base-usdc-to-susdc'
    }
  }

  if (chainId === arbitrum.id) {
    if (token.symbol === usds && savingsToken.symbol === susds) {
      return 'arbitrum-usds-to-susds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susds) {
      return 'arbitrum-usdc-to-susds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susdc) {
      return 'arbitrum-usdc-to-susdc'
    }
  }

  if (chainId === optimism.id) {
    if (token.symbol === usds && savingsToken.symbol === susds) {
      return 'optimism-usds-to-susds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susds) {
      return 'optimism-usdc-to-susds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susdc) {
      return 'optimism-usdc-to-susdc'
    }
  }

  if (chainId === unichain.id) {
    if (token.symbol === usds && savingsToken.symbol === susds) {
      return 'unichain-usds-to-susds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susds) {
      return 'unichain-usdc-to-susds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susdc) {
      return 'unichain-usdc-to-susdc'
    }
  }

  if (chainId === avalanche.id) {
    if (token.symbol === usdc && savingsToken.symbol === spusdc) {
      return 'avalanche-usdc-to-spusdc'
    }
  }

  if (token.symbol === usds && savingsToken.symbol === susds) {
    return 'usds-to-susds'
  }

  if (token.symbol === dai && savingsToken.symbol === susds) {
    return 'dai-to-susds'
  }

  if (token.symbol === usdc && savingsToken.symbol === susds) {
    return 'usdc-to-susds'
  }

  if (token.symbol === dai && savingsToken.symbol === sdai) {
    return 'dai-to-sdai'
  }

  if (token.symbol === usdc && savingsToken.symbol === susdc) {
    return 'usdc-to-susdc'
  }

  if (token.symbol === usds && savingsToken.symbol === stusds) {
    return 'usds-to-stusds'
  }

  if (token.symbol === weth && savingsToken.symbol === speth) {
    return 'weth-to-speth'
  }

  if (token.symbol === eth && savingsToken.symbol === speth) {
    return 'eth-to-speth'
  }

  if (token.symbol === usdc && savingsToken.symbol === spusdc) {
    return 'usdc-to-spusdc'
  }

  if (token.symbol === usdt && savingsToken.symbol === spusdt) {
    return 'usdt-to-spusdt'
  }

  if (token.symbol === pyusd && savingsToken.symbol === sppyusd) {
    return 'pyusd-to-sppyusd'
  }

  raise('Savings deposit action type not recognized')
}
